import React from 'react';
import styled from '../../styled';
import { DemoButton } from '../DemoButton';

const SectionWrapper = styled('section')`
  padding: 40px 24px;
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;

  @media (max-width: 960px) {
    padding: 80px 24px;
  }
`;

const Quote = styled('blockquote')`
  font-size: 32px;
  font-weight: 400;
  line-height: 1.5;
  color: #0e1c2b;
  margin: 0 0 40px 0;
  font-style: italic;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;

  @media (max-width: 960px) {
    font-size: 28px;
  }

  @media (max-width: 600px) {
    font-size: 24px;
  }
`;

const AuthorWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
`;

const LogoImage = styled('img')`
  width: 130px;
  height: auto;
  opacity: 0.8;
  transition: opacity 0.2s, filter 0.2s;

  &:hover {
    opacity: 1;
    filter: grayscale(0%);
  }
`;

const AuthorInfo = styled('div')`
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: 4px;
`;

const AuthorName = styled('div')`
  font-size: 16px;
  font-weight: 600;
  color: #0e1c2b;
`;

const AuthorTitle = styled('div')`
  font-size: 14px;
  color: #4f4f4f;
`;

export const TestimonialSection = () => {
  return (
    <SectionWrapper>
      <Quote>
        "The level of detail we can see now is a total game-changer. We're able
        to make smarter, faster decisions, and it's showing up in the revenue."
      </Quote>
      <AuthorWrapper>
        <AuthorInfo>
          <AuthorName>Jim Ryan</AuthorName>
          <AuthorTitle>
            Sr Director of Affiliate Strategy, Commerce Content
          </AuthorTitle>
        </AuthorInfo>
        <LogoImage src="/images/logos/usa-today.svg" alt="USA Today" />
      </AuthorWrapper>
      <br />
      <br />
      <DemoButton text="Get a demo" variant="contained" />
    </SectionWrapper>
  );
};
